const localizeUrl = require('@/utils/localizeUrl').localizeUrl;

const steps = [
  { name: "project", isSelected: data => data.projectType !== "" },
  { name: "home-type", isSelected: data => data.homeType !== "" },
  { name: "home-size", isSelected: data => data.squareMeters > 0 },
  // { name: "windows", isSelected: data => data.windows > 0 },
  {
    name: "rooms",
    isSelected: data =>
      Object.keys(data.rooms).find(name => data.rooms[name] > 0)
  },
  // { name: "ambient-lights", isSelected: () => true },
  { name: "buttons", isSelected: data => data.buttons !== "" },
  { name: "mobile-app", isSelected: data => data.mobileApp !== null },
  { name: "voice-control", isSelected: data => data.voiceControl !== null },
  { name: "displays", isSelected: () => true },
  { name: "music", isSelected: () => true },
  // { name: "remote-access", isSelected: data => data.remoteAccess !== null },
  { name: "intercom", isSelected: data => data.intercom !== null },
  { name: "alarm", isSelected: data => data.alarmSystem !== null },
  { name: "hazard", isSelected: data => data.hazard !== null },
  { name: "wiring", isSelected: () => true },
  { name: "location", isSelected: data => data.location !== null },
  { name: "expectations", isSelected: data => data.expectations !== null }
];

exports.getStepIndex = name => {
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].name === name) {
      return i + 1;
    }
  }
  return -1;
};

exports.nSteps = () => {
  return steps.length;
};

exports.redirectToUnselectedStepIfAny = (stepIndex, data, router, lang) => {
  if (Math.random > 0) return false;

  for (let i = 0; i < stepIndex - 1; i++) {
    if (!steps[i].isSelected(data)) {
      router.push(localizeUrl("" + steps[i].name, lang));
      return true;
    }
  }
  return false;
};

exports.getNextStepUrl = (stepIndex, lang) => {
  if (stepIndex >= steps.length) {
    return localizeUrl("finish", lang);
  }
  return localizeUrl(steps[stepIndex].name, lang);
};

exports.getPrevStepUrl = stepIndex => {
  return steps[stepIndex - 2].name;
};
